import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { node, TreeComponent } from 'src/app/construct-x/shared/components/elems/tree/tree.component';

@Component({
    selector: 'app-dialog-certificate-detail',
    imports: [TreeComponent],
    templateUrl: './dialog-certificate-detail.component.html',
    styleUrls: ['./dialog-certificate-detail.component.scss', '../../../../../components/dialog-windows/dialog.css']
})
export class DialogCertificateDetailComponent {

    constructor(public dialogRef: MatDialogRef<DialogCertificateDetailComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogCertificateDetailData
    ) {}

    onClose(): void {
        this.dialogRef.close();
    }
}

export interface DialogCertificateDetailData {
    title: string;
    treeData: node[];
    certKeys: { key: string; separator: string }[];
}
